import * as React from 'react'
import classNames from 'classnames'
import throttle from 'lodash.throttle'
import { DropTarget as dropTarget } from 'react-dnd-cjs'
import { createStructuredSelector } from 'reselect'
import { Actions, connect, Selectors } from '@react-page/core/lib'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/pro-regular-svg-icons/faTrash'

import * as S from './styled'

const target = {
    hover: throttle(
        (props, monitor) => {
            const item = monitor.getItem()
            if (monitor.isOver({ shallow: true })) {
                item.clearHover()
            }
        },
        200,
        { trailing: false }
    ),

    drop(props, monitor) {
        const item = monitor.getItem()
        if (monitor.didDrop() || !monitor.isOver({ shallow: true })) {
            // If the item drop occurred deeper down the tree, don't do anything
            return
        }

        props.removeCell(item.id)
    },
}

const connectMonitor = (_connect, monitor) => ({
    connectDropTarget: _connect.dropTarget(),
    isOverCurrent: monitor.isOver({ shallow: true }),
})

const Raw = ({ connectDropTarget, isOverCurrent, isLayoutMode }) =>
    connectDropTarget(
        <div
            className={classNames('ory-controls-trash', {
                'ory-controls-trash-active': isLayoutMode,
            })}
        >
            <button color="secondary" disabled={!isOverCurrent} data-testid="trash-button">
                <FontAwesomeIcon icon={faTrash} />
            </button>
        </div>
    )

const types = ({ editor }) => {
    const {
        plugins: {
            plugins: { content, layout },
        },
    } = editor

    const plugins = [
        ...Object.keys(layout).map(p => layout[p].name),
        ...Object.keys(content).map(p => content[p].name),
    ]

    if (editor.plugins.hasNativePlugin()) {
        plugins.push(editor.plugins.getNativePlugin()().name)
    }

    return plugins
}

const mapDispatchToProps = {
    removeCell: Actions.Cell.removeCell,
}

const mapStateToProps = createStructuredSelector(Selectors.Display)

const Decorated = connect(
    mapStateToProps,
    mapDispatchToProps
)(dropTarget(types, target, connectMonitor)(Raw))

const Trash = ({ editor }) => {
    return (
        <S.Trash>
            <Decorated editor={editor} />
        </S.Trash>
    )
}

export default Trash
